import { PageHeader } from '@/components/page-header';
import QContainer from '@/components/q-container/q-container.vue';
import QLabel from '@/components/q-container/q-label.vue';
import QTreeContainer from '@/components/q-container/q-tree-container.vue';
import Vue from 'vue';

export function setupComponents() {
    Vue.component('PageHeader', PageHeader);
    Vue.component('QContainer', QContainer);
    Vue.component('QTreeContainer', QTreeContainer);
    Vue.component('QLabel', QLabel);
}

export * from './reuse-tab';
